import React from 'react';
import { Input, Checkbox, Card, Tag } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';
import { ENOCH_DEFAULT_CONFIG_NAME } from '../enoch-config.helpers';
import { mapIpToMachineName } from 'containers/Performance/EnochPerf/common';
import { capitalize } from 'lodash';
import DomainInputs from './DomainInputs';
import SubjectInputs from './SubjectInputs';
import RatesInput from './RatesInput';
import RestartOptions from './RestartOptions';
import WaitTimeInput from './WaitTimeInput';
import ActivityOptions from './ActivityOptions';
import SelectProfiles from './SelectProfiles';

const EnochConfigForm = (props: { vm: string }) => {
  const isDefaultConfiguration = props.vm === ENOCH_DEFAULT_CONFIG_NAME;

  const { control, watch } = useFormContext();
  const useDefaultConfig = watch('useDefaultConfig');

  return (
    <div className="enoch-config-form">
      <header>
        <div className="text">
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
            {capitalize(mapIpToMachineName[props.vm] || props.vm)}
            <div style={{ marginBottom: 15, marginLeft: 10 }}>
              {!isDefaultConfiguration && (
                <Tag
                  color={
                    props.machineState === 'DISCONNECTED'
                      ? 'red'
                      : props.machineState === 'RUNNING'
                      ? 'green'
                      : 'blue'
                  }
                >
                  {props.machineState}
                </Tag>
              )}
            </div>
          </div>
        </div>
        {!isDefaultConfiguration && (
          <div className="checkbox">
            <Controller
              control={control}
              name="useDefaultConfig"
              render={({ field: { value, onChange } }) => {
                return (
                  <Checkbox
                    checked={value}
                    onChange={e => onChange(e.target.checked)}
                  >
                    USE DEFAULT CONFIGURATION
                  </Checkbox>
                );
              }}
            />
          </div>
        )}
      </header>

      <Card className="card">
        {!isDefaultConfiguration && (
          <>
            <Controller
              control={control}
              name="userDataDir"
              render={({ field: { value, onChange, onBlur } }) => {
                return (
                  <Input
                    addonBefore="User Data Dir"
                    placeholder="Enter user data dir"
                    value={value}
                    onBlur={onBlur}
                    onChange={e => onChange(e.target.value)}
                  />
                );
              }}
              rules={{ required: true }}
            />

            <SelectProfiles vm={props.vm} />
          </>
        )}

        {(!useDefaultConfig || isDefaultConfiguration) && (
          <Controller
            control={control}
            name="sendCountConfig.count"
            render={({ field }) => {
              return (
                <Input
                  addonBefore="Number of emails to send per run (0 = unlimited)"
                  type="number"
                  value={field.value}
                  onBlur={field.onBlur}
                  onChange={e => {
                    field.onChange(Number(e.target.value));
                  }}
                />
              );
            }}
          />
        )}
      </Card>

      {(!useDefaultConfig || isDefaultConfiguration) && (
        <>
          <SubjectInputs />

          <DomainInputs />

          <Card className="card">
            <WaitTimeInput />

            <RatesInput name="defaultRates" />
          </Card>

          <ActivityOptions />

          <RestartOptions />
        </>
      )}
    </div>
  );
};

export default EnochConfigForm;
